export default __webpack_public_path__ + "static/adreno-ignite-yoga-c78ccaea58beffebfb4b3171908ef883.jpg";